/* eslint-disable linebreak-style */
import React, { useState, useRef, useEffect } from 'react'
import { Formik, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import moment from 'moment'
import FormField from '../../../components/Form/FormField'
import Button from '../../../components/Button'
import FlexLayout from '../../../components/FlexLayout'
import stockApi from '../../../services/StockApi'
import Table from '../../../components/Table'
import Select from '../../../components/Select'
import Text from '../../../components/Text'
import NumberFormat from 'react-number-format'
import { DarkBlue } from '../../../assets/colors'
import { ReceivementFreshTag } from '../../../components/Tags/ReceivementFreshTag'
import ReceivementFreshPendencyTag from '../../../components/Tags/ReceivementFreshPendencyTag'
import { ReceivementGondolaTag } from '../../../components/Tags/ReceivementGondolaTag'
import TagPrinterManager from '../../../components/TagPrinterManager'

import Helper, { addLeadingZeros } from '../../../services/Helper'
import FormFieldNumber from '../../../components/Form/FormFieldNumber'

import useDeleteBatch from './hooks/useDeleteBatch'

import { TrashButton } from '../../../components/TrashButton'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'

import { actions } from '../../../features/state'
import { useDispatch } from 'react-redux'

function ReceivementFreshForm({
  setReadyTable,
  receivementTable,
  setNotReadyTable,
  pendencyReceivementTable,
  receivementId,
  barcodeUser,
  errorProducts,
  setErrorProducts
}) {
  const [product, setProduct] = useState(undefined)

  const [productStock, setProductStock] = useState(undefined)
  const [errors, setErrors] = useState({})
  const [checked, setChecked] = useState({})
  const [gondolaActive, setGondolaActive] = useState(true)
  const { fc } = useFulfillmentCenter()
  const streetfieldsStyle = {
    width: '50px'
  }
  const expirationDateRef = useRef()
  const addButtonRef = useRef()
  const barcodeRef = useRef()

  const [tagsToPrint, setTagsToPrint] = useState([])
  const [showTagManagerModal, setShowTagManagerModal] = useState(false)

  const dispatch = useDispatch()

  const fieldStyle = {
    background: 'rgba(246, 246, 246, 0.6)',
    border: 0,
    borderBottom: `3px solid ${DarkBlue}`,
    width: '100%'
  }

  useEffect(() => {
    barcodeRef.current.focus()
  }, [])

  const [addressError, setAddressError] = useState('')

  function cleanForm(setFieldValue) {
    setFieldValue('product', '', false)
    setFieldValue('amount', '', false)
    setFieldValue('receivementMeasureUnity', '', false)
    setFieldValue('itemTemperature', '', false)
    setFieldValue('expirationDate', '', false)
    setFieldValue('shed', '', false)
    setFieldValue('street', '', false)
    setFieldValue('shelf', '', false)
    setFieldValue('bin', '', false)
    setFieldValue('id_localizacao', 0, false)
    setFieldValue('pendency', false, false)
    setFieldValue('status', '', false)
    setFieldValue('billetBarCode', '', false)
  }

  function barcodeOnKeyDown(event, barcode, setFieldValue) {
    if (event.key === 'Enter' || event.key === 'Tab') {
      SearchProductInfo(barcode, setFieldValue)
    }
  }

  function SearchProductInfo(barcode, setFieldValue) {
    if (checked.barcode === barcode)
      return Promise.resolve(checked.barcodeValue)

    dispatch(actions.isLoading(true))

    cleanForm(setFieldValue)
    const promise = stockApi
      .get(`/estoque/${barcode}`, {
        params: {
          fulfillment_center_id: fc.id
        }
      })
      .then((response) => {
        const { estoques } = response.data
        setProductStock(estoques)

        stockApi
          .get(`/produtos/${barcode}`, {
            params: {
              fulfillment_center_id: fc.id
            }
          })
          .then((res) => {
            setErrors({})
            const produto = res.data
            setProduct(produto)

            setFieldValue('product', produto.desc_produto, false)

            setFieldValue(
              'receivementMeasureUnity',
              produto?.measure_unit?.desc,
              false
            )

            setGondolaActive(true)
            setFieldValue('shed', produto.galpao, false)
            setFieldValue('street', produto.rua, false)
            setFieldValue('shelf', produto.posicao, false)
            setFieldValue('bin', produto.nivel, false)
          })
          .catch((err) => {
            setErrors({ error: err.response.data.message })
          })
      })
      .catch((error) => {
        setProductStock(undefined)
        setProduct(undefined)
        setGondolaActive(false)
        setFieldValue('pendency', true, false)
        setFieldValue('status', 'PRODUCT_NOT_FOUND', false)
        setFieldValue('product', 'PRODUTO NÃO ENCONTRADO', false)
        setErrors(error.response.data.message)
        return false
      })
      .finally(() => {
        dispatch(actions.isLoading(false))
      })
    setChecked((prev) => ({ ...prev, barcode, barcodeValue: promise }))
    return promise
  }

  function checkLocalization(shed, street, shelf, bin) {
    const endereco = {
      galpao: shed,
      rua: street,
      posicao: shelf,
      escaninho: bin,
      fulfillment_center_id: fc.id
    }
    return stockApi
      .post('/estoque/localizacao/validar', endereco)
      .then((resp) => {
        if (resp.data['endereço validado'].status_code === 'OK') {
          return {
            id_localizacao: resp.data['endereço validado'].id_localizacao,
            shed: shed,
            street: street,
            shelf: shelf,
            bin: bin,
            fulfillment_center_id: fc.id,
            pendency: false,
            status: resp.data['endereço validado'].status_code
          }
        } else {
          throw resp.data['endereço validado']
        }
      })
      .catch((error) => {
        throw error
      })
  }

  function cleanErrorsMessage() {
    setAddressError('')
    setErrors({})
  }

  function addTable(values, resetForm, setSubmitting) {
    cleanErrorsMessage()
    let lotRow, pendencyRow

    checkLocalization(values.shed, values.street, values.shelf, values.bin)
      .then((resp) => {
        return resp
      })
      .then((resp) => {
        if (values.pendency === false) {
          lotRow = receivementTable.filter(
            (row) =>
              row.barcode.toUpperCase() === values.barcode.toUpperCase() &&
              row.expirationDate ===
                moment(values.expirationDate, 'YYYY-MM-DD').format(
                  'DD/MM/YYYY'
                ) &&
              row.address ===
                `${resp.shed}-${resp.street}-${resp.shelf}-${resp.bin}`
          )[0]
        } else {
          pendencyRow = pendencyReceivementTable.filter(
            (row) =>
              row.barcode.toUpperCase() === values.barcode.toUpperCase() &&
              row.expirationDate ===
                moment(values.expirationDate, 'YYYY-MM-DD').format(
                  'DD/MM/YYYY'
                ) &&
              row.address ===
                `${resp.shed}-${resp.street}-${resp.shelf}-${resp.bin}`
          )[0]
        }

        const options = {
          headers: {
            'user-barcode': barcodeUser
          }
        }
        const data = [
          {
            id_recebimento: receivementId,
            cod_barras: values.barcode.trim(),
            quantidade: values.amount,
            unidade_medida_recebimento: values.receivementMeasureUnity,
            data_validade: values.expirationDate,
            id_localizacao: resp.id_localizacao,
            tipo_recebimento: Helper.TypesReceivement.FRESH,
            temperatura_item:
              values.itemTemperature == undefined ? '' : values.itemTemperature,
            id_lote: lotRow ? lotRow.lot : undefined,
            id_pendencia: pendencyRow ? pendencyRow.pendencyId : undefined
          }
        ]

        stockApi
          .post('/recebimento/lote', data, options)
          .then((res) => {
            setErrors({})
            const informacoesLote = res.data.informacoes[0]
            if (informacoesLote.pendencia) {
              let newItem = {
                description: values.product,
                barcode: values.barcode,
                amount: values.amount,
                receivementMeasureUnity: values.receivementMeasureUnity,
                itemTemperature: values.itemTemperature,
                expirationDate: moment(
                  values.expirationDate,
                  'YYYY-MM-DD'
                ).format('DD/MM/YYYY'),
                shed: resp.shed,
                street: resp.street,
                shelf: resp.shelf,
                bin: resp.bin,
                address: `${resp.shed}-${resp.street}-${resp.shelf}-${resp.bin}`,
                status: resp.status,
                lot: informacoesLote.lote ? informacoesLote.lote : null,
                pendencyId: informacoesLote.pendencia.id_pendencia,
                entryDate: informacoesLote.data_entrada
                  ? informacoesLote.data_entrada
                  : informacoesLote.pendencia.data_pendencia,
                printed: false
              }

              newItem.actions = (
                <>
                  <TrashButton
                    handleClick={function () {
                      handleClickBatchRemove(newItem)
                    }}
                  />
                </>
              )

              setTagsToPrint([<ReceivementFreshPendencyTag obj={newItem} />])
              setErrorProducts('')
              setShowTagManagerModal(true)

              setNotReadyTable((table) => {
                if (pendencyRow) {
                  let indexRow = table.indexOf(pendencyRow)
                  let pendencyTableUpdated = table
                  pendencyTableUpdated[indexRow].amount += values.amount
                  return [...pendencyTableUpdated]
                } else {
                  table.push(newItem)
                  return [...table]
                }
              })
            } else {
              let newItem = {
                description: values.product,
                barcode: values.barcode,
                amount: values.amount,
                receivementMeasureUnity: values.receivementMeasureUnity,
                itemTemperature: values.itemTemperature,
                expirationDate: moment(
                  values.expirationDate,
                  'YYYY-MM-DD'
                ).format('DD/MM/YYYY'),
                shed: resp.shed,
                street: resp.street,
                shelf: resp.shelf,
                bin: resp.bin,
                address: `${resp.shed}-${resp.street}-${resp.shelf}-${resp.bin}`,
                lot: informacoesLote.lote,
                modelId: informacoesLote.cod_modelo,
                entryDate: informacoesLote.data_entrada,
                printed: false,
                fc: informacoesLote.fc?.name
              }

              newItem.actions = (
                <>
                  <TrashButton
                    handleClick={function () {
                      handleClickBatchRemove(newItem)
                    }}
                  />
                </>
              )

              setTagsToPrint([<ReceivementFreshTag obj={newItem} />])
              setErrorProducts('')
              setShowTagManagerModal(true)

              setReadyTable((table) => {
                if (lotRow) {
                  let indexRow = table.indexOf(lotRow)
                  let receivementTableUpdated = table
                  receivementTableUpdated[indexRow].amount += values.amount
                  return [...receivementTableUpdated]
                } else {
                  table.push(newItem)
                  return [...table]
                }
              })
            }
            resetForm({ values: '' })
            setSubmitting(false)
            setChecked({})
          })
          .catch((error) => {
            setSubmitting(false)
            let message_error = ''
            if (error.response && error.response.data) {
              if (error.response.data.message) {
                message_error = error.response.data.message
                setErrors({ error: message_error })
              }
            } else {
              message_error = 'Ocorreu um problema na conexão com o servidor!'
              setErrors({ error: message_error })
            }
          })
      })
      .catch((error) => {
        setSubmitting(false)
        if (error.status_code === 'ADDRESS_NOT_FOUND') {
          setAddressError(error.message)
        } else if (error.response) {
          let message = error.response.data.message
          setAddressError(message)
        } else {
          console.log(error)
          setErrors({ error: 'Ocorreu um erro inesperado' })
          throw error
        }
      })
  }

  const handleFinishPrint = () => {
    setTagsToPrint([])
    setShowTagManagerModal(false)
  }

  const [handleClickBatchRemove, DeleteModalComponent] = useDeleteBatch({
    setReadyTable,
    setNotReadyTable
  })

  return (
    <>
      <Formik
        initialValues={{
          barcode: '',
          product: '',
          amount: '',
          receivementMeasureUnity: '',
          itemTemperature: '',
          expirationDate: '',
          shed: '',
          street: '',
          shelf: '',
          bin: '',
          id_localizacao: 0,
          pendency: false,
          status: '',
          billetBarCode: ''
        }}
        validationSchema={Yup.object().shape({
          barcode: Yup.string().required('form.required'),
          expirationDate: Yup.date()
            .required('form.required')
            .min(Date(), 'A data de validade não pode estar vencida'),
          amount: Yup.number()
            .required('form.required')
            .nullable()
            .test(
              'validate-amount',
              'receivement.form.amount.error',
              (value) => value > 0
            ),
          itemTemperature: Yup.string().test(
            'itemTemperature',
            'receivement.form.error.itemTemperature',
            (values) =>
              values != undefined
                ? parseFloat(values) <= 999.9 && parseFloat(values) >= -999.9
                : true
          )
        })}
        validateOnChange={false}
        validateOnBlur
        onSubmit={(values, { resetForm, setSubmitting, setFieldValue }) => {
          barcodeRef.current.focus()
          addTable(values, resetForm, setSubmitting, setFieldValue)
        }}
      >
        {({
          values,
          setFieldValue,
          handleSubmit,
          isSubmitting,
          setTouched,
          validateField
        }) => (
          <Form>
            <FormField
              label="receivement.form.barcode"
              name="barcode"
              fieldRef={barcodeRef}
              autoComplete='off'
              onKeyDown={(e) => barcodeOnKeyDown(e, values.barcode, setFieldValue)}
              testId='input-barcode'
            />
            <FormField
              label="receivement.form.product"
              isDisabled
              name="product"
              testId='input-product'
            />

            <FlexLayout>
              <FormFieldNumber
                name="amount"
                label="receivement.form.amount"
                value={values.amount}
                {...(product?.measure_unit?.is_fractionable && {
                  decimalScale: 3
                })}
                onBlur={() => {
                  validateField('amount')
                  setTouched(values)
                }}
                onValueChange={(val) => {
                  setFieldValue('amount', val.floatValue, true)
                }}
                styleContainer={{ width: '70%' }}
                testId='input-amount'
              />
              <FormField
                label="receivement.form.receivement_measure_unity"
                isDisabled
                name="receivementMeasureUnity"
                styleContainer={{ width: '30%' }}
                testId='input-measure-unit'
              />
            </FlexLayout>

            <FlexLayout direction="column" style={{ margin: '15px 0 0 0' }}>
              <Text textType="defaut" text="receivement.form.itemTemperature" />
              <NumberFormat
                name="itemTemperature"
                decimalSeparator=","
                decimalScale={1}
                allowLeadingZeros={false}
                allowNegative={true}
                allowEmptyFormatting={false}
                value={values.itemTemperature}
                onValueChange={(val) => {
                  setFieldValue('itemTemperature', val.floatValue, false)
                }}
                style={fieldStyle}
                maxLength={6}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') {
                    expirationDateRef.current.focus()
                  }
                }}
                data-testid='input-car-temperature'
              />
              <ErrorMessage
                component={Text}
                name="itemTemperature"
                style={{ color: 'red' }}
              />
            </FlexLayout>

            <FormField
              label="receivement.form.expirationDate"
              fieldType="date"
              name="expirationDate"
              fieldRef={expirationDateRef}
              testId='input-expiration-date'
            />
            <FlexLayout>
              <FormField
                label="receivement.form.address.shed"
                name="shed"
                isDisabled={gondolaActive}
                style={streetfieldsStyle}
                onChange={(e) =>
                  setFieldValue('shed', e.target.value.toUpperCase())
                }
                testId='input-address-shed'
              />
              <FormField
                label="receivement.form.address.street"
                name="street"
                isDisabled={gondolaActive}
                style={streetfieldsStyle}
                onChange={(e) =>
                  setFieldValue('street', e.target.value.toUpperCase())
                }
                testId='input-address-street'
              />
              <FormField
                label="receivement.form.address.shelf"
                name="shelf"
                isDisabled={gondolaActive}
                style={streetfieldsStyle}
                onChange={(e) =>
                  setFieldValue('shelf', e.target.value.toUpperCase())
                }
                onKeyUp={(e) => {
                  setFieldValue('shelf', addLeadingZeros(e.target.value, 3))
                }}
                testId='input-address-shelf'
              />
              <FormField
                label="receivement.form.address.bin"
                name="bin"
                isDisabled={gondolaActive}
                style={streetfieldsStyle}
                onChange={(e) =>
                  setFieldValue('bin', e.target.value.toUpperCase())
                }
                testId='input-address-bin'
              />
            </FlexLayout>

            <FlexLayout justify="between" style={{ margin: '10px 5px 0 0' }}>
              <Button
                type="button"
                text="Gondola"
                style={{ marginRight: '5px', opacity: gondolaActive ? 1 : 0.5 }}
                isDisabled={gondolaActive}
                onClick={() => {
                  if (product) {
                    setFieldValue('shed', product.galpao)
                    setFieldValue('street', product.rua)
                    setFieldValue('shelf', product.posicao)
                    setFieldValue('bin', product.nivel)
                    setGondolaActive(true)
                  } else {
                    setFieldValue('shed', '')
                    setFieldValue('street', '')
                    setFieldValue('shelf', '')
                    setFieldValue('bin', '')
                    setGondolaActive(false)
                  }
                }}
                disabledColor={DarkBlue}
              />
              <Button
                type="button"
                text="Outros"
                style={{
                  marginRight: '5px',
                  opacity: !gondolaActive ? 1 : 0.5
                }}
                isDisabled={!gondolaActive}
                disabledColor={DarkBlue}
                onClick={() => setGondolaActive(false)}
              />
            </FlexLayout>

            {addressError && (
              <p style={{ color: 'red', marginTop: '10px' }}>
                {' '}
                {addressError}{' '}
              </p>
            )}
            {productStock && productStock.length > 0 && (
              <FlexLayout style={{ margin: '15px 0 0 0' }}>
                <Table
                  name="receivement.form.address.table"
                  headers={[
                    {
                      name: 'address',
                      label: 'receivement.table.header.address'
                    },
                    {
                      name: 'amount',
                      label: 'receivement.table.header.amount'
                    },
                    {
                      name: 'expirationDate',
                      label: 'receivement.table.header.expirationDate'
                    }
                  ]}
                  initData={productStock.map((item) => ({
                    address: `${item.galpao}-${item.rua}-${item.posicao_pallete}-${item.escaninho_nivel}`,
                    amount: item.quantidade,
                    expirationDate: item.data_validade,
                    extra: (
                      <Select
                        onClick={() => {
                          setFieldValue('shed', item.galpao)
                          setFieldValue('street', item.rua)
                          setFieldValue('shelf', item.posicao_pallete)
                          setFieldValue('bin', item.escaninho_nivel)
                          setGondolaActive(false)
                        }}
                      />
                    )
                  }))}
                  style={{ marginTop: '12px' }}
                />
              </FlexLayout>
            )}

            {errorProducts && (
              <p style={{ color: 'red', fontSize: '14px', margin: '15px 0' }}>
                {errorProducts}
              </p>
            )}
            {errors && errors.error && (
              <Text style={{ color: 'red' }}>{errors.error}</Text>
            )}
            <FlexLayout justify="end" style={{ margin: '15px 0' }}>
              <Button
                className="submit-button"
                type="button"
                text="add"
                style={{ marginRight: '5px' }}
                innerRef={addButtonRef}
                onClick={!isSubmitting ? handleSubmit : () => {}}
                isDisabled={isSubmitting}
                testId='button-add-product'
              />
            </FlexLayout>
          </Form>
        )}
      </Formik>
      {tagsToPrint && tagsToPrint.length > 0 && (
        <TagPrinterManager
          setShowTagModal={setShowTagManagerModal}
          showTagModal={showTagManagerModal}
          labelsToPrint={tagsToPrint}
          setLabelsToPrint={setTagsToPrint}
          donePrint={handleFinishPrint}
        />
      )}

      <DeleteModalComponent />
    </>
  )
}

export default ReceivementFreshForm
